import React from "react";
import type { OrderTableRow } from "../../types";
import ModalHeader from "./modalHeader";

// 発注登録一覧 削除モーダル
export interface Props {
  order: OrderTableRow;
  onClose: () => void;
  onDelete: () => Promise<void>;
}

export const OrderDeleteModal: React.FC<Props> = ({ order, onClose, onDelete }) => {
  return (
    <div className="modal">
      <div className="content">
        <ModalHeader title="発注登録" onClose={onClose} />
        <div>
          <p>削除しますか？</p>
          <p>登録日：{order.orderAddDate}</p>
          <p>販売業者：{order.vendorName}</p>
          <p>薬剤：{order.chemicalName}</p>
          <p>納入予定日：{order.scheduledDate}</p>
        </div>

        <div className="parts actions">
          <button onClick={onClose} className="negative">
            キャンセル
          </button>
          <button onClick={onDelete} className="positive">
            削除
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderDeleteModal;
